<template>
    <div id="forget">
        <main class="main-container">
            <div class="right_text">
                <h3><span @click="toIndex"></span>找回密码</h3>
                <el-form :label-position="labelPosition" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="130px" class="login-ruleForm">
                    <el-form-item label="登录名：" prop="userName">
                        <el-input type="text" :maxlength="11" v-model="ruleForm.userName"  @input="getValue" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码：" prop="verificationCode" class="sendWrap">
                        <el-input v-model="ruleForm.verificationCode"></el-input>
                        <!--<span class="sendCode" @click="sendCode">发送验证码</span>-->
                        <el-button :class="{ sendCodeActive: (isCanSend && ruleForm.userName) }" @click="sendCode" :loading="isSend">发送验证码</el-button>
                        <span class="countDown" style="display:none;">60s</span>
                    </el-form-item>
                    <el-form-item label="密码：" prop="password">
                        <el-input type="password" :maxlength="20" v-model="ruleForm.password" clearable auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="再次输入密码：" prop="enPass">
                        <el-input type="password" :maxlength="20" v-model="ruleForm.enPass" clearable auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item size="large">
                        <el-button type="primary" @click="submitForm('ruleForm')">修改密码</el-button>
                    </el-form-item>
                </el-form>
                <div class="other">
                    <span class="forgetPass" @click="$router.push('/login/masterCenter')">返回登录</span>
                    <p>
                        <span class="helpCenter" @click="toHelp">帮助中心</span>
                        <!--<span class="line"></span>-->
                        <!--<span class="registerNow" @click="$router.push('/register')">立即注册</span>-->
                    </p>
                </div>
            </div>
        </main>
        <div class="copyright">版权所有Copyright©2018 ΜΟΜΛ当代节能置业招采平台</div>
    </div>
</template>
<script>
    import md5 from 'js-md5';
    export default {
        name: 'forget',
        data() {
            return {
                isCanSend: false,//是否可以发送验证码
                isSend: false,//是否发送了验证码
                labelPosition: 'left',
                ruleForm: {
                    userName: '',
                    password: '',
                    enPass: '',
                    verificationCode:'',
                    codeKey: ''
                },
                rules: {
                    userName: [
                        { required: true, message: '登录账号为手机号'},
//                        { validator: 'regexp', pattern: /^[0-9]{11}$/, message: '手机号码格式不正确', trigger: 'blur'},
                        {validator: this.validateUserFormat, trigger: 'blur'},
                        {validator: this.validateUser, trigger: 'blur'},
                    ],
                    password: [
                        {required: true, message: '请输入登录密码'},
                        {validator: 'regexp', pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,message: '密码为6-20位数字和字母的组合', trigger: 'blur'},
                        {validator: this.validatePass, trigger: 'blur'}
                    ],
                    enPass: [
                        {required: true, message: '请再次输入登录密码'},
                        {
                            validator: 'regexp',
                            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,
                            message: '密码为6-20位数字和字母的组合',
                            trigger: 'blur'
                        },
                        {validator: this.validatePass2, trigger: 'blur'}
                    ],
                    verificationCode: [
                        { required: true, message: '请输入验证码'}
                    ]
                }
            }
        },
        methods: {
            getValue(val){//获取值。
                if(val.length < 11){
                    this.isCanSend = false;
                }
            },
            validateUser(rule,value,callback){
                var _this = this;
                this.$http.get('/v1/sSuppliers/public/checkLoginName/'+value+'/2').then(res => {
//                    console.log(res);
                    if(res.data.code == 1){
                        _this.isCanSend = true;
                        callback();
                    } else {
                        _this.isCanSend = false;
                        callback(new Error('用户名不存在'));
                    }
                });
            },
            validateUserFormat(rule,value,callback){
                let reg = /^[0-9]{11}$/;
                let _this = this;
                if(reg.test(value)){
                    _this.isCanSend = true;
                    callback();
                } else {
                    _this.isCanSend = false;
                    callback(new Error('手机号码格式不正确'));
                }
            },
            validatePass(rule, value, callback){//验证密码
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if (this.ruleForm.enPass !== '') {
                        this.$refs.ruleForm.validateField('enPass');
                    }
                    callback();
                }
            },
            validatePass2(rule, value, callback){//验证确认密码
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.ruleForm.password) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            },
            toIndex(){
                this.$root.activeIndex = 'home';
                this.$router.push('/');
            },
            toHelp(){
                this.$root.activeIndex = 'setting';
                this.$router.push('/help')
            },
            getUuid() {//公用方法，生成uid,用来获取验证码
                let s = [];
                let hexDigits = "0123456789abcdef";
                for (let i = 0; i < 36; i++) {
                    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
                }
                s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
                s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
                s[8] = s[13] = s[18] = s[23] = "";

                let uuid = s.join("");
                return uuid;
            },
            sendCode(){//发送验证码
                var _this = this;
                let code = this.getUuid();
                this.ruleForm.codeKey = code;
                var countDownEl = document.querySelector('.countDown');
                var sendCodeEl = document.querySelector('.sendWrap .el-button');
                _this.$refs.ruleForm.validateField('userName',function(err){
                    if(!err){//如果没有错误信息，就代表手机号验证通过了，就发送验证码；
                        _this.isSend = true;
                        _this.$root.getHttp(`v1/login/public/sendSmsCode/${_this.ruleForm.userName}`,function(res){
//                            console.log('验证码',res);
                            _this.isSend = false;
                            countDownEl.style.display = 'block';//发送成功,显示倒计时；
                            sendCodeEl.style.display = 'none';
                            var time = setInterval(function(){
                                if(parseInt(countDownEl.innerHTML) == 1){
                                    countDownEl.innerHTML = '60S';
                                    countDownEl.style.display = 'none';
                                    sendCodeEl.style.display = 'block';
                                    clearInterval(time);
                                    return;
                                }
                                countDownEl.innerHTML = parseInt(countDownEl.innerHTML)-1 + 'S';
                            },1000);
                        })
                    } else {
                        console.log('error')
                    }
                })
            },
            submitForm(formName) {
                var _this = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        _this.$root.postHttp('/v1/login/public/restFindPassword',{
                            "codeKey": _this.ruleForm.codeKey,
                            "password": md5(_this.ruleForm.password),
                            "userName": _this.ruleForm.userName,
                            "verificationCode": _this.ruleForm.verificationCode
                        },function(res){
//                            console.log('submit')
                            _this.$alert('重置密码成功', '提示', {
                                confirmButtonText: '确定',
                                type: 'success',
                                callback: action => {
                                   _this.$router.push('/login/masterCenter');
                                }
                            });
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        }
    }
</script>
<style lang="scss">
    @import "../../assets/_var.scss";

    #forget {
        position: relative;
        height: 100vh;
        box-sizing: border-box;
        padding-top: 60px;
        background: url("../../assets/images/login/bg.jpg") no-repeat 0 0/100% 100%;
        & main {
            width: 945px;
            & .right_text {
                margin: 0px auto;
                width: 400px;
                padding: 50px 35px;
                background: #fff;
                box-shadow: 0 0 15px rgba(0,0,0,.2);
                & h3 {
                    line-height: 32px;
                    /*padding-left: 210px;*/
                    text-align: left;
                    color: $--text-color;
                    & span {
                        display: inline-block;
                        vertical-align: middle;
                        margin-right: 20px;
                        width: 200px;
                        height: 32px;
                        cursor: pointer;
                        background: url("../../assets/images/topBar1/logoIcon.png") no-repeat 0 0/200px auto;
                    }
                }
                & .el-form {
                    margin-top: 15px;
                    & .el-form-item {
                        border: 1px solid $--secondary-fill-color;
                        border-radius: 3px;
                        & .el-form-item__label {
                            padding: 0;
                        }
                        & .el-form-item__label::before {
                            content: '';
                            display: inline-block;
                            margin: 0 5px 0 5px;
                            margin-top: -5px;
                            vertical-align: middle;
                            width: 20px;
                            height: 20px;
                            background: url('../../assets/images/login/icon01.png') no-repeat 0 0;
                        }
                        & .el-form-item__content {
                            width: 280px;
                        }
                        & .el-input__inner {
                            border: none;
                            padding: 0;
                        }
                    }
                    & .el-form-item:nth-of-type(2){
                        & .el-input__suffix {
                            right: 103px;
                        }
                        & .el-form-item__label::before {
                            background: url('../../assets/images/login/icon03.png') no-repeat 0 0;
                        }
                        & .el-form-item__content {
                            position: relative;
                            & .el-button {
                                background: #ccc;
                                position: absolute;
                                right: 4px;
                                top: 4px;
                                padding: 0;
                                width: 98px;
                                height: 32px;
                                line-height: 32px;
                                cursor: pointer;
                                color: #fff;
                                border-radius: 3px;
                                transition: .5s;
                            }
                            .sendCodeActive,
                            .el-button:hover {
                                background: $--primary-color;
                            }
                            & .countDown {
                                background: #cb1235;
                                position: absolute;
                                right: 4px;
                                top: 4px;
                                width: 88px;
                                height: 32px;
                                line-height: 32px;
                                cursor: pointer;
                                color: #fff;
                                border-radius: 3px;
                            }
                        }
                    }
                    & .el-form-item:nth-of-type(3),
                    & .el-form-item:nth-of-type(4) {
                        & .el-form-item__label::before {
                            background: url('../../assets/images/login/icon02.png') no-repeat 0 0;
                        }
                    }
                    & .el-form-item:nth-of-type(5) {
                        border: none;
                        & .el-form-item__content {
                            margin-left: 0;
                            & button {
                                width: 400px;
                                margin-left: -117px;
                            }
                        }
                    }
                }
                & .other {
                    overflow: hidden;
                    font-size: 12px;
                    cursor: pointer;
                    & .forgetPass {
                        float: left;
                        color: $--primary-color;
                    }
                    & p {
                        float: right;
                        color: $--text-color-lighter;
                        & .line {
                            margin: 0 8px;
                            border-left: 1px solid $--text-color-lighter;
                        }
                    }
                }
            }
        }
        & .copyright {
            margin-top: 30px;
            font-size: 12px;
            color: $--text-color-lighter;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/common/Forget.vue